import { AfterViewInit, Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[enableUpdateSubmit]'
})
export class EnableDisableMultiSelectSubmitButtonDirective implements AfterViewInit,OnChanges {
  @Input() enableUpdateSubmit:boolean;//Whether the search container is expanded or not. false == collapsed
  btn:ElementRef;
  
  constructor(private el: ElementRef, 
    private renderer: Renderer2) { }

    ngAfterViewInit(): void {
      //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
      //Add 'implements AfterViewInit' to the class.
      setTimeout(() => {
        this.btn = this.el.nativeElement.querySelector("button.multi-submit-btn");
      }, 1000);
        
    }

    ngOnChanges(changes: SimpleChanges): void {
      //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
      //Add '${implements OnChanges}' to the class.
      if(changes["enableUpdateSubmit"]){
       if(this.btn){
          this.toggle()
        }
      }
    }

    toggle():void{
      this.enableUpdateSubmit? this.endableBtn() : this.disableBtn();
    }
  
    endableBtn():void{
      this.renderer.removeClass(this.btn,"btn-disabled");
      this.renderer.removeAttribute(this.btn,"disabled");
    }
  
    disableBtn():void{
      this.renderer.setAttribute(this.btn,"disabled","")
    }

}
